export const setStep = (state, step) => {
    state.steps = step;
};

export const checkOrgans = (state, list) => {
    state.organs = list;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js